import { useState, useRef } from "react";
import "./ClawPollPositionsSelector.scss";

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const UNUSABLE = {
    "_10x10": 4,
    "_15x15": 6,
    "_20x20": 8,
}
const MAX_SELECTABLE = 4;

const ClawPollPositionsSelector = (props) => {
    const gridSizeSetting = props.customisationData?.inGameVisuals?.positionSelect?.playerGrid?.[0]?.gridTiles ?? '20x20';
    const gridSizeNumber = parseInt(gridSizeSetting.split('x')[0]);

    const [selectedPositions, setSelectedPositions] = useState([]);
    // const [previouslySelectedPositions, setPreviouslySelectedPositions] = useState([]);
    const showToolTip = (e, colIndex, rowIndex) => {
        const positionString = `${LETTERS[colIndex]}-${gridSizeNumber - rowIndex}`;
        props.showTooltipFunc(`&nbsp;&nbsp;#${positionString}&nbsp;&nbsp;`, e);
    }
    const hideToolTip = (e) => {
        props.hideTooltipFunc(e);
    }

    const tooltipTimeoutRef = useRef(null);

    const receivedData = props.passedInPreviewData?.pollControl ?? props.featureVars?.pollControl ?? {};
    console.log('Received Data', receivedData);
    const receivedForcedPollOptions = receivedData.forcedPollOptions ?? [];
    const lastSelectedOption = receivedData.lastSelectedOption;
    const lastPollOptions = receivedData.lastPollOptions ?? [];
    const lastForcePollOptions = receivedData.lastForcePollOptions ?? [];
    if (receivedForcedPollOptions === 'clear') {
        // Time to clear the selected options as there are no longer any forced options
        if (selectedPositions.length > 0) {
            // setPreviouslySelectedPositions(selectedPositions);
            setSelectedPositions([]);
        }
    }

    return (
        <div className="claw-poll-positions-selector">
            <div className="position-selector-row">
                {[...Array(gridSizeNumber)].map((_, colIndex) => (
                    <div className="label-box" key={colIndex}>
                        {LETTERS[colIndex]}
                    </div>
                ))}
                <div className="label-box">
                    {' '}
                </div>
            </div>
            {[...Array(gridSizeNumber)].map((_, rowIndex) => (
                <div className="position-selector-row" key={rowIndex}>
                    {[...Array(gridSizeNumber)].map((_, colIndex) => {
                        const positionString = `${LETTERS[colIndex]}-${gridSizeNumber - rowIndex}`;
                        const useablePos = !(UNUSABLE[`_${gridSizeNumber}x${gridSizeNumber}`] && colIndex < UNUSABLE[`_${gridSizeNumber}x${gridSizeNumber}`] && rowIndex >= gridSizeNumber - UNUSABLE[`_${gridSizeNumber}x${gridSizeNumber}`]);
                        const selectablePos = selectedPositions.length < MAX_SELECTABLE || selectedPositions.includes(positionString);
                        const selectedPos = selectedPositions.includes(positionString);
                        return(
                            <div className={`position-selector-box${colIndex === gridSizeNumber - 1 ? ' last-in-row' : ''}${useablePos && rowIndex === gridSizeNumber - 1 ? ' last-row' : ''}${!useablePos ? ' unavailable' : ''}${!selectablePos ? ' unselectable' : ''}${selectedPos ? ' selected' : ''}`} 
                                key={colIndex}
                                onClick={(e) => {
                                    const positionString = `${LETTERS[colIndex]}-${gridSizeNumber - rowIndex}`;
                                    let newSelectedPositions = [...selectedPositions];
                                    if (newSelectedPositions.includes(positionString)) {
                                        newSelectedPositions = newSelectedPositions.filter(pos => pos !== positionString);
                                    } else {
                                        if (newSelectedPositions.length < MAX_SELECTABLE) {
                                            newSelectedPositions.push(positionString);
                                        }
                                    }
                                    setSelectedPositions(newSelectedPositions);
                                    props.sendFeatureCommandFunc(e, 'FORCE_POSITION_POLL_OPTIONS', props.featureId, {options: newSelectedPositions});
                                }}
                                onMouseEnter={useablePos && selectablePos ? (e) => {
                                    tooltipTimeoutRef.current = setTimeout(() => showToolTip(e, colIndex, rowIndex), 100);
                                } : null}
                                onMouseLeave={(e) => {
                                    clearTimeout(tooltipTimeoutRef.current);
                                    hideToolTip(e);
                                }}
                            >
                                {selectedPos &&
                                    <div className="selected-position-grid-pos-marker">
                                        {positionString}
                                    </div>
                                }
                                {(lastPollOptions.includes(positionString) || lastSelectedOption === positionString) &&
                                    <div className={`previous-poll-option${lastPollOptions.includes(positionString) ? ' in-poll' : ''}${lastSelectedOption === positionString ? ' chosen' : ''}${lastSelectedOption !== positionString && lastPollOptions.includes(positionString) && lastForcePollOptions.includes(positionString) ? ' forced' : ''}`}></div>
                                }
                            </div>
                        )
                    })}
                    <div className="label-box">
                        {(gridSizeNumber - rowIndex).toString()}
                    </div>
                </div>
            ))}
            <div className="poll-legend">
                <div className="poll-legend-item">
                    <div className="color-box">
                        <div className="previous-poll-option in-poll"></div>
                    </div>
                    <div className="grow">In Last Poll</div>
                </div>
                <div className="poll-legend-item">
                    <div className="color-box">
                        <div className="previous-poll-option in-poll forced"></div>
                    </div>
                    <div className="grow">Forced Position</div>
                </div>
                <div className="poll-legend-item">
                    <div className="color-box">
                        <div className="previous-poll-option in-poll chosen"></div>
                    </div>
                    <div className="grow">Last Played Position</div>
                </div>
            </div>
        </div>
    );
}

export default ClawPollPositionsSelector;
